import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwarcabpackage() {



  const cardData =
  {
    keyword: 'Pune to Mahabaleshwar Cab Package',
    heading: 'Sanavi Travels: Pune to Mahabaleshwar Cab Package',
    headingDescription: 'Sanavi Travels offers reliable Pune to Mahabaleshwar Cab Package, providing safe, comfortable, and hassle-free transportation for families, friends, couples, and corporate groups planning a scenic getaway from Pune to Mahabaleshwar. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space to ensure a smooth and relaxing journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Mahabaleshwar attractions such as Venna Lake, Arthur’s Seat, Mapro Garden, Lingmala Waterfall, and Wilson Point. Choose Sanavi Travels for trusted Pune to Mahabaleshwar cab packages, delivering comfort, safety, and a memorable hill-station travel experience.',

    top: 'Top Places to Visit in Mahabaleshwar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is Mahabaleshwar’s most famous viewpoint, offering panoramic views of the lush valleys and the Krishna River. Often called the ‘Queen of all points,’ it is especially stunning during sunrise and sunset. Surrounded by greenery and cool mist, it is a favorite spot for tourists and nature lovers."
  },
  {
    "title": "Venna Lake",
    "description": "Venna Lake is a picturesque artificial lake in Mahabaleshwar, surrounded by trees and gardens. Boating and horse rides are popular activities here. The serene environment and scenic surroundings make it ideal for picnics, leisure walks, and relaxation amidst nature."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, located near Mahabaleshwar, is a historic hill fort known for the legendary battle between Chhatrapati Shivaji Maharaj and Afzal Khan. The fort offers breathtaking views of the Sahyadri ranges and surrounding valleys. It is a major attraction for history enthusiasts and trekkers."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a scenic viewpoint in Mahabaleshwar, named for the rock formation resembling an elephant’s head. It offers stunning views of the Sahyadri hills and surrounding forests. The point is especially beautiful during monsoon, with misty landscapes and flowing streams."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a popular tourist attraction and strawberry farm in Mahabaleshwar. Visitors can enjoy fresh strawberry-based products, including jams, juices, and desserts. The garden also has a cafe and a gift shop, making it a perfect stop for families and food lovers."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a scenic waterfall near Mahabaleshwar, especially spectacular during the monsoon season. Surrounded by lush greenery and rocky terrain, it is a popular spot for photography, nature walks, and short treks."
  },
  {
    "title": "Bombay Point",
    "description": "Bombay Point is the sunset point of Mahabaleshwar, offering mesmerizing views of the valleys and hills. Tourists gather here in the evening to witness breathtaking sunsets. It is a serene spot ideal for photography and quiet contemplation."
  },
  {
    "title": "Kate’s Point",
    "description": "Kate’s Point is a popular viewpoint overlooking the Krishna Valley and Dhom Dam. Surrounded by dense forests, it offers panoramic views and trekking opportunities. The point is especially attractive during monsoon with misty landscapes."
  },
  {
    "title": "Wilson Point",
    "description": "Wilson Point, also known as Sunrise Point, is the highest point in Mahabaleshwar. It offers spectacular views of the sunrise over the Sahyadri hills. Early morning visitors enjoy cool breezes, scenic beauty, and peaceful surroundings."
  },
  {
    "title": "Connaught Peak",
    "description": "Connaught Peak is one of the highest peaks in Mahabaleshwar, offering breathtaking views of the surrounding hills and valleys. It is ideal for trekking enthusiasts and nature lovers seeking adventure and panoramic vistas."
  }
]
,




"services": [
  {
    "name": "Pune to Mahabaleshwar Cab Package",
    "description": "Pune to Mahabaleshwar Cab Package offers comfortable and reliable cab services for travelers planning a trip from Pune to Mahabaleshwar. Ideal for families, friends, and couples, these cabs ensure a smooth journey with professional drivers, flexible pickup options, and well-maintained vehicles."
  },
  {
    "name": "Mahabaleshwar Cab from Pune",
    "description": "Mahabaleshwar Cab from Pune provides convenient transportation for tourists and travelers seeking hassle-free travel. Equipped with spacious interiors and experienced chauffeurs, this service is perfect for sightseeing, weekend trips, and outstation travel."
  },
  {
    "name": "AC Cab Pune to Mahabaleshwar",
    "description": "AC Cab Pune to Mahabaleshwar ensures a comfortable and cool journey with air-conditioned vehicles. Perfect for long drives, family trips, and leisure travel, passengers can relax while professional drivers manage the route efficiently."
  },
  {
    "name": "Luxury Cab Mahabaleshwar Trip",
    "description": "Luxury Cab Mahabaleshwar Trip provides premium vehicles with modern amenities for an elegant travel experience. Ideal for VIP travel, family outings, and special occasions, these cabs offer comfort, style, and punctual service."
  },
  {
    "name": "Family Cab Package Mahabaleshwar",
    "description": "Family Cab Package Mahabaleshwar caters to families traveling from Pune to Mahabaleshwar. Spacious vehicles, child-friendly interiors, and experienced drivers ensure a safe, convenient, and enjoyable journey for all family members."
  },
  {
    "name": "Outstation Cab Pune to Mahabaleshwar",
    "description": "Outstation Cab Pune to Mahabaleshwar offers reliable cabs for long-distance travel between Pune and Mahabaleshwar. Comfortable seating, luggage space, and professional chauffeurs make it ideal for weekend trips, holidays, and group travel."
  },
  {
    "name": "Affordable Cab Mahabaleshwar",
    "description": "Affordable Cab Mahabaleshwar provides budget-friendly cab options without compromising comfort or safety. Perfect for solo travelers, families, and small groups seeking economical travel solutions from Pune to Mahabaleshwar."
  },
  {
    "name": "Chauffeur Driven Cab Mahabaleshwar",
    "description": "Chauffeur Driven Cab Mahabaleshwar ensures a stress-free travel experience with professional drivers handling traffic, routes, and pick-ups. Passengers can relax and enjoy the scenic journey between Pune and Mahabaleshwar."
  },
  {
    "name": "Best Cab Service Pune to Mahabaleshwar",
    "description": "Best Cab Service Pune to Mahabaleshwar offers top-quality vehicles and excellent customer service for a superior travel experience. Timely pick-ups, well-maintained cars, and skilled drivers ensure safe and reliable transport."
  },
  {
    "name": "Pune Mahabaleshwar Taxi",
    "description": "Pune Mahabaleshwar Taxi provides convenient and reliable taxi services for individuals and groups. Spacious, comfortable, and well-maintained vehicles make long-distance travel from Pune to Mahabaleshwar effortless and enjoyable."
  },
  {
    "name": "Tourist Cab Mahabaleshwar",
    "description": "Tourist Cab Mahabaleshwar offers cabs specially suited for sightseeing and tourist trips. Comfortable seating, luggage-friendly interiors, and professional chauffeurs provide a smooth and enjoyable travel experience."
  },
  {
    "name": "Weekend Trip Cab Pune",
    "description": "Weekend Trip Cab Pune provides cabs for short getaways from Pune to Mahabaleshwar. Ideal for weekend travelers, couples, and friends, ensuring punctual service, comfortable vehicles, and scenic drives."
  },
  {
    "name": "Hill Station Cab Pune",
    "description": "Hill Station Cab Pune offers reliable transportation for trips to Mahabaleshwar and other nearby hill stations. Equipped with comfortable interiors and professional drivers, these cabs make hilly drives safe and enjoyable."
  },
  {
    "name": "Mahabaleshwar Travel Cab",
    "description": "Mahabaleshwar Travel Cab provides dependable cab services for all types of travel, including leisure, sightseeing, and family outings. Well-maintained vehicles and courteous drivers ensure a hassle-free journey from Pune."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to conveniently reserve cabs for Pune to Mahabaleshwar trips. Flexible scheduling, transparent pricing, and professional service make planning your journey easy and reliable."
  }
],
"tableData": [
  ["Pune to Mahabaleshwar Cab Package", "Mahabaleshwar Cab from Pune"],
  ["AC Cab Pune to Mahabaleshwar", "Luxury Cab Mahabaleshwar Trip"],
  ["Family Cab Package Mahabaleshwar", "Outstation Cab Pune to Mahabaleshwar"],
  ["Affordable Cab Mahabaleshwar", "Chauffeur Driven Cab Mahabaleshwar"],
  ["Best Cab Service Pune to Mahabaleshwar", "Pune Mahabaleshwar Taxi"],
  ["Tourist Cab Mahabaleshwar", "Weekend Trip Cab Pune"],
  ["Hill Station Cab Pune", "Mahabaleshwar Travel Cab"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mahabaleshwar Cab Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers convenient and reliable Pune to Mahabaleshwar cab packages, perfect for family trips, couples getaways, and sightseeing tours in the hill station."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in air-conditioned, spacious, and regularly serviced cabs for a smooth and relaxing journey from Pune to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Hill Station Routes",
    "WhyChoosedescription": "Our professional drivers are experienced in Pune to Mahabaleshwar routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for Pune to Mahabaleshwar cab packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel inquiries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages based on your travel preferences and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Mahabaleshwar cab packages."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab packages from Pune to Mahabaleshwar?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab packages for travel from Pune to Mahabaleshwar.'
  },
  {
    question: 'How can I book a Pune to Mahabaleshwar cab package?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of cabs are available for Pune to Mahabaleshwar trips?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for a comfortable journey.'
  },
  {
    question: 'Are drivers experienced for Pune to Mahabaleshwar routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the route to ensure safe travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup in Pune and drop-off anywhere in Mahabaleshwar.'
  },
  {
    question: 'Is the cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services for your convenience.'
  },
  {
    question: 'Are safety and hygiene protocols followed?',
    answer: 'All cabs are sanitized regularly, and drivers follow strict safety and hygiene guidelines.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate account payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your travel from Pune to Mahabaleshwar.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'The Pune to Mahabaleshwar cab package with Sanavi Travels was excellent. Comfortable ride, punctual service, and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Radhika Kulkarni',
    feedback: 'Highly recommended! The cab was clean, air-conditioned, and the driver was very courteous. Perfect trip to Mahabaleshwar.',
    rating: 5
  }
];













































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Cab Package - Sanavi Travels",
  "description": "Book Pune to Mahabaleshwar cab package with Sanavi Travels. AC and luxury cabs for family trips, weekend getaways, hill station tours, outstation travel, and comfortable chauffeur-driven journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Pune to Mahabaleshwar Cab Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Mahabaleshwar with Sanavi Travels. Ideal for family trips, weekend getaways, hill station tours, outstation travel, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwarcabpackage;